import CalendarContext from '@/context/CalendarContext';
import useCalendarOnlyForContext from '@/hooks/calendar/useCalendarOnlyForContext';

export const CalendarProvider = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const useCalendarOutcome = useCalendarOnlyForContext();

	return (
		<CalendarContext.Provider value={useCalendarOutcome}>
			{children}
		</CalendarContext.Provider>
	);
};
